import React from 'react';
import { Grid, Card, CardContent, Typography, Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField, InputAdornment, Modal, IconButton, Button } from '@mui/material';
import { Search } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';

const TransactionTable = ({ title, headers, transactions, onStatusClick, onSearchChange, openModal, handleCloseModal, selectedTransaction, handleCaptureClick, captureSuccess }) => {
  const convertTimestampToDate = (timestamp) => {
    // Your date conversion logic here
    return new Date(timestamp).toLocaleDateString();
  };
console.log("transactions",transactions)
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  };

  return (
    <Grid container spacing={2} sx={{ mt: 2,width:'100%' ,height:'90%',overflow:'auto'}}>
      <Grid item xs={12}  sx={{width:'100%',height:'100%'}}>
        <Card sx={{overflow:'auto'}}>
          <CardContent>
            <Typography variant="h6" component="div">{title}</Typography>
          
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    {headers&&headers.map((header, index) => (
                      <TableCell key={index}>{header}</TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {transactions.map((transaction, rowIndex) => (
                    <TableRow key={rowIndex}>
                      {Object.keys(transaction).map((key, cellIndex) => (
                        <TableCell key={cellIndex}>
                          {key === 'status' ? (
                            <Typography
                              color={transaction[key] === 'Delivered' ? 'green' : transaction[key] === 'PENDING' ? 'orange' : 'red'}
                              onClick={() => onStatusClick && onStatusClick(transaction)}
                              style={{ cursor: onStatusClick ? 'pointer' : 'default' }}
                            >
                              {transaction[key]}
                            </Typography>
                          ) : (
                            transaction[key]
                          )}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      </Grid>

      {/* Modal for Transaction Details */}
      <Modal
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="transaction-modal-title"
        aria-describedby="transaction-modal-description"
      >
        <Box sx={style}>
          <IconButton
            aria-label="close"
            onClick={handleCloseModal}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
          <Typography id="transaction-modal-title" variant="h6" component="h2" sx={{fontWeight:'bold'}}>
            Transaction Details
          </Typography>
          <Typography id="transaction-modal-description" sx={{ mt: 2 }}>
            <strong>Order ID:</strong> {selectedTransaction?.id}
          </Typography>
          <Typography><strong>Status:</strong> {selectedTransaction?.status}</Typography>
          <Typography><strong>Amount:</strong> {selectedTransaction?.amount}</Typography>
          <Typography><strong>Date:</strong> {convertTimestampToDate(selectedTransaction?.created_at)}</Typography>

          {selectedTransaction?.status === 'authorized' && !captureSuccess && (
            <Button
              variant="contained"
              sx={{ mt: 2, backgroundColor: '#3f51b5', color: 'white' }}
              onClick={handleCaptureClick}
            >
              Capture
            </Button>
          )}

          {captureSuccess && (
            <Typography sx={{ mt: 2, color: 'green' }}>
              Successfully Captured!
            </Typography>
          )}
        </Box>
      </Modal>
    </Grid>
  );
};

export default TransactionTable;
